import { LANDING_PAGE_URL } from '@src/configs';
import FemaleVoiceIcon from '@src/assets/images/female-voice.png';
import MaleVoiceIcon from '@src/assets/images/male-voice.png';

const VOICE_CLONING_SAMPLE_AUDIO = [
  {
    name: 'Phương Vy',
    description: 'Bắc Ninh',
    icon: FemaleVoiceIcon,
    originalVoice: `${LANDING_PAGE_URL}/audios/voice-cloning/demo/female-root.MP3`,
    cloneVoice: `${LANDING_PAGE_URL}/audios/voice-cloning/demo/female-clone.mp3`,
  },
  {
    name: 'Nhật Minh',
    description: 'Hà Nội',
    icon: MaleVoiceIcon,
    originalVoice: `${LANDING_PAGE_URL}/audios/voice-cloning/demo/male-root.MP3`,
    cloneVoice: `${LANDING_PAGE_URL}/audios/voice-cloning/demo/male-clone.mp3`,
  },
];

export { VOICE_CLONING_SAMPLE_AUDIO };
